import React from "react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Our Modules
import { MenuItem, SubMenuItem } from "./MenuItems";

export const PopExpandButton = handlePopExpand => ({
  key: "popExpand",
  text: i18n._(t`Expand report`),
  iconProps: { iconName: "MiniExpand" },
  commandBarButtonAs: props => <MenuItem {...props} />,
  onClick: () => handlePopExpand(true)
});

export const EditButton = (isAuthO, item, page, category, id, tab) => {
  const disabled = !isAuthO("edit", item) || !item || item.readOnlyRole;
  if (disabled)
    return {
      key: "edit",
      text: i18n._(t`Edit`),
      disabled: true,
      iconProps: {
        iconName: "Edit"
      },
      commandBarButtonAs: props => <MenuItem {...props} itemId={id} />
    };
  return {
    key: "edit",
    text: i18n._(t`Edit`),
    iconProps: {
      iconName: "Edit"
    },
    commandBarButtonAs: props => <MenuItem {...props} itemId={id} />,
    link: `/${page}/${category}/edit/${id}?tab=${tab}`
  };
};

export const DownloadCSVButton = (handleOnClick, text) => {
  return {
    key: "edit",
    id: "downloadCsvButton",
    text: text,
    iconProps: {
      iconName: "MailAttached"
    },
    commandBarButtonAs: props => <MenuItem {...props} />,
    onClick: () => handleOnClick()
  };
};

export const GoBackButton = (page, category, id, tab) => {
  return {
    key: "back",
    text: i18n._(t`Go Back`),
    iconProps: {
      iconName: "Back"
    },
    commandBarButtonAs: props => <MenuItem {...props} />,
    link: `/${page}/${category}/view/${id}?tab=${tab}`
  };
};

// Calls handleSave on click (Ex. Assign and unassign users)
export const SaveChangesButton = (handleSave, items, buttonName) => {
  return {
    key: "save",
    text: buttonName,
    iconProps: {
      iconName: "Save"
    },
    commandBarButtonAs: props => <MenuItem {...props} />,
    onClick: () => handleSave(items)
  };
};

// Cancle with go back link
export const CancelChangesButton = (page, category, id, tab) => {
  return {
    key: "cancel",
    text: i18n._(t`Cancel Changes`),
    iconProps: {
      iconName: "Cancel"
    },
    commandBarButtonAs: props => <MenuItem {...props} />,
    link: `/${page}/${category}/view/${id}?tab=${tab}`
  };
};

// Calls save on click (New Role)
export const SaveButton = (saveNewItem, newItem) => ({
  key: "save",
  text: i18n._(t`Save`),
  disabled: newItem ? !newItem.isValid : false,
  iconProps: {
    iconName: "Save"
  },
  onClick: saveNewItem,
  commandBarButtonAs: props => {
    return <MenuItem {...props} />;
  }
});

// Calls toggleDeleteDialog on click
export const DeleteButton = (isAuthO, item, toggleDeleteDialog) => ({
  key: "delete",
  text: i18n._(t`Delete`),
  disabled: !isAuthO("delete", item) || !item || item.readOnly,
  iconProps: {
    iconName: "Delete"
  },
  onClick: () => {
    toggleDeleteDialog();
  },
  commandBarButtonAs: props => {
    return <MenuItem {...props} />;
  }
});

// New technical or business role button
export const NewButton = isAuthO => ({
  key: "new",
  text: i18n._(t`New`),
  iconProps: {
    iconName: "Add"
  },
  subMenuProps: {
    onItemClick: () => true,
    contextualMenuItemAs: props => <SubMenuItem {...props} />,
    items: [
      {
        key: "role",
        disabled: !isAuthO("new", { type: "roles" }),
        text: i18n._(t`Technical Role`),
        iconProps: {
          iconName: "RowsGroup"
        },
        link: "/role/roles/new"
      },
      {
        key: "rolegroup",
        text: i18n._(t`Business Role`),
        iconProps: {
          iconName: "EngineeringGroup"
        },
        link: "/role/rolegroups/new"
      }
    ],
    isBeakVisible: false
  }
});

export const CancelNewButton = (page, category, cancelNewItem) => ({
  key: "Cancel",
  text: i18n._(t`Cancel`),
  iconProps: {
    iconName: "Cancel"
  },
  onClick: cancelNewItem,
  commandBarButtonAs: props => <MenuItem {...props} />,
  link: `/${page}/${category}`
});

export const AssignEmployeesButton = (isAuthO, item, page, category, id) => {
  const disabled = !isAuthO("assign", item) || !item || item.static;
  if (disabled)
    return {
      key: "assign",
      text: i18n._(t`Assign Employees`),
      disabled: true,
      iconProps: {
        iconName: "CircleAddition"
      },
      commandBarButtonAs: props => <MenuItem {...props} itemId={id} />
    };
  return {
    key: "assign",
    text: i18n._(t`Assign Employees`),
    disabled: !isAuthO("assign", item) || !item || item.static,
    iconProps: {
      iconName: "CircleAddition"
    },
    commandBarButtonAs: props => <MenuItem {...props} itemId={id} />,
    link: `/${page}/${category}/assignemployees/${id}`
  };
};

export const UnassignEmployeesButton = (isAuthO, item, page, category, id) => {
  const disabled = !isAuthO("assign", item) || !item || item.static;
  if (disabled)
    return {
      key: "unassign",
      text: i18n._(t`Unassign Employees`),
      disabled: true,
      iconProps: {
        iconName: "RemoveFilter"
      },
      commandBarButtonAs: props => <MenuItem {...props} itemId={id} />
    };
  return {
    key: "unassign",
    text: i18n._(t`Unassign Employees`),
    disabled: !isAuthO("assign", item) || !item || item.static,
    iconProps: {
      iconName: "RemoveFilter"
    },
    commandBarButtonAs: props => <MenuItem {...props} itemId={id} />,
    link: `/${page}/${category}/unassignemployees/${id}`
  };
};

export const ApproveEmployeeButton = (
  setIsDialogHidden,
  isFetchingItem,
  disabled
) => ({
  key: "activateEmployee",
  disabled: isFetchingItem || disabled,
  text: i18n._(t`Activate Employee`),
  iconProps: { iconName: "UserFollowed" },
  commandBarButtonAs: props => <MenuItem {...props} />,
  onClick: () => setIsDialogHidden(false)
});

export const AssignOrgUnitsButton = (isAuthO, item, page, category, id) => {
  const disabled = !isAuthO("assign", item) || !item || item.static;
  if (disabled)
    return {
      key: "assign",
      text: i18n._(t`Assign Organisational Units`),
      disabled: true,
      iconProps: {
        iconName: "CircleAddition"
      },
      commandBarButtonAs: props => <MenuItem {...props} itemId={id} />
    };
  return {
    key: "assign",
    text: i18n._(t`Assign Organisation Units`),
    disabled: !isAuthO("assign", item) || !item || item.static,
    iconProps: {
      iconName: "CircleAddition"
    },
    commandBarButtonAs: props => <MenuItem {...props} itemId={id} />,
    link: `/${page}/${category}/assignorgunits/${id}`
  };
};

export const UnassignOrgUnitsButton = (isAuthO, item, page, category, id) => {
  const disabled = !isAuthO("assign", item) || !item || item.static;
  if (disabled)
    return {
      key: "unassign",
      text: i18n._(t`Unassign Organisational Units`),
      disabled: true,
      iconProps: {
        iconName: "RemoveFilter"
      },
      commandBarButtonAs: props => <MenuItem {...props} itemId={id} />
    };
  return {
    key: "unassign",
    text: i18n._(t`Unassign Organisational Units`),
    disabled: !isAuthO("assign", item) || !item || item.static,
    iconProps: {
      iconName: "RemoveFilter"
    },
    commandBarButtonAs: props => <MenuItem {...props} itemId={id} />,
    link: `/${page}/${category}/unassignorgunits/${id}`
  };
};

// Enables activity list
export const ActivityButton = (setIsActivityVisible, isFetchingItem) => ({
  key: "activity",
  disabled: isFetchingItem,
  text: i18n._(t`View Activity List`),
  iconProps: { iconName: "History" },
  commandBarButtonAs: props => <MenuItem {...props} />,
  onClick: () => setIsActivityVisible(true)
});
